export const isMobile = (): boolean => {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') {
    return false
  }

  const userAgent = navigator.userAgent.toLowerCase()
  const mobileRegex = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini|mobile/i

  return mobileRegex.test(userAgent)
}

export type ClientOs = 'macos' | 'windows' | 'linux' | 'unknown'

// 探测用户本机 OS：用于达芬奇渲染时拼 NAS 挂载根（本次仅支持 macOS）。
// 由浏览器探测、随只读接口上报后端，因 server 进程 OS ≠ 用户本机 OS。
export const detectClientOs = (): ClientOs => {
  if (typeof navigator === 'undefined') {
    return 'unknown'
  }
  const ua = navigator.userAgent.toLowerCase()
  if (ua.includes('mac')) {
    return 'macos'
  }
  if (ua.includes('win')) {
    return 'windows'
  }
  if (ua.includes('linux')) {
    return 'linux'
  }
  return 'unknown'
}
